import { Rectangle } from '../../interfaces';
import { PageElement } from './page-element';

export class WordElement extends PageElement {
    private _isIgnored: boolean = false;

    get textContent(): string | null {
        return (this.element as Element).textContent;
    }

    get boundary(): Rectangle | null{
        if(this.element){
            let box = (this.element as Element).getAttribute('box');
            if(box){
                const [x, y, width, height] = box.split(',');
                return { x: parseFloat(x), y: parseFloat(y), width: parseFloat(width), height: parseFloat(height) };
            }
        }
        return null;
    }

    get isIgnored(): boolean {
        return this._isIgnored;
    }

    set isIgnored(value: boolean) {
        this._isIgnored = value;
    }
}
